import './Contacto.css'

const Contacto = () => {
    return (
        <picture>
            <img src='/assets/img/proximamente.png' alt='imagen proximamente' className="ProximamenteImg" />
        </picture>
    )
}

export default Contacto